import '@fontsource/chakra-petch/latin-700.css'
import '@fontsource-variable/inter/index.css'
import '@fontsource/nunito-sans/latin-400.css'
import '@fontsource/nunito-sans/latin-500.css'
import '@fontsource/nunito-sans/latin-600.css'
import '@fontsource/nunito-sans/latin-700.css'
import '@/app/styles/main.css'

import { createPinia } from 'pinia'
import { createApp, watch } from 'vue'

import App from '@/app/App.vue'
import { router } from '@/app/router'
import {
  ADMIN_SESSION_EVENT_KEY,
  type AdminSessionEvent,
  useAuthStore,
} from '@/features/auth/stores/auth.store'
import {
  setAccessTokenResolver,
  setSessionRefreshHandler,
  setUnauthorizedHandler,
} from '@/shared/api/http'
import { useTheme } from '@/shared/composables/useTheme'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)

const authStore = useAuthStore(pinia)
setAccessTokenResolver(() => authStore.accessToken)
setSessionRefreshHandler(() => authStore.refreshAccessToken())
setUnauthorizedHandler(() => {
  const redirect = router.currentRoute.value.fullPath
  authStore.clearSession()
  if (authStore.initialized && router.currentRoute.value.name !== 'login') {
    void router.replace({ name: 'login', query: { redirect } })
  }
})

window.addEventListener('storage', (event) => {
  if (event.key !== ADMIN_SESSION_EVENT_KEY || !event.newValue) return
  try {
    const value = JSON.parse(event.newValue) as { type?: AdminSessionEvent }
    if (value.type === 'authenticated' || value.type === 'signed-out') {
      void authStore.syncSessionEvent(value.type)
    }
  } catch {
    // Ignore malformed same-origin events.
  }
})

watch(
  () => authStore.isAuthenticated,
  (authenticated) => {
    if (!authStore.initialized) return
    if (!authenticated && router.currentRoute.value.meta.requiresAuth) {
      void router.replace({
        name: 'login',
        query: { redirect: router.currentRoute.value.fullPath },
      })
    } else if (authenticated && router.currentRoute.value.name === 'login') {
      void router.replace({ name: 'overview' })
    }
  },
)

await authStore.initialize()

app.use(router)
useTheme()

app.mount('#app')
